import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import { dispatch, useSelector } from "store";
import useConfig from "hooks/useConfig";
import { HORIZONTAL_MAX_ITEM } from "config";
import { openDrawer } from "store/reducers/menu";
import { MenuOrientation } from "config";
import {
  Home3,
  Profile2User,
  Calendar1,
  Award,
  UserTag,
  TableDocument,
  DocumentText,
  Messages2,
  Record,
  MenuBoard,
  Note,
  Judge,
  Box1,
  Grid3,
  More,
} from "iconsax-react";
import HistoryIcon from "@mui/icons-material/History";
import ReportIcon from "@mui/icons-material/Report";
import {
  checkPermission,
  ConvertToKebabCase,
  getItem,
  getPermssionDataByName,
} from "services/utils";
import { FeedbackTwoTone, Timeline } from "@mui/icons-material";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";
import withRouter from "components/withRouter";
import { HambergerMenu } from "iconsax-react";
import { FormatConstants } from "services/keyConstants";
import { getMasterDocDataByKey } from "services/ReduxUtils";

// icons
const icons = {
  dashboard: Home3,
  client: Profile2User,
  standard: Award,
  roles: UserTag,
  Record: Record,
  ReportIcon: ReportIcon,
  MenuBoard: MenuBoard,
  table: TableDocument,
  calendar: Calendar1,
  history: HistoryIcon,
  Judge: Judge,
  documentText: DocumentText,
  Note: Note,
  FeedbackTwoTone: FeedbackTwoTone,
  Messages2: Messages2,
  Box: Box1,
  Grid: Grid3,
  finish: CheckCircleOutlineIcon,
  general: AutoAwesomeMosaicIcon,
  more: More,
  ChangeHistoryIcon: ChangeHistoryIcon,
  Timeline: Timeline,
};

const Hamberger = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 12.9336C5.47523 12.9336 8.70047 12.9336 12.0234 12.9336C12.0234 13.4325 12.0234 13.9313 12.0234 14.4453C8.7982 14.4453 5.57297 14.4453 2.25 14.4453C2.25 13.9464 2.25 13.4476 2.25 12.9336Z"
      fill="black"
    />
    <path
      d="M2.25 5.44531C5.47523 5.44531 8.70047 5.44531 12.0234 5.44531C12.0234 5.94418 12.0234 6.44305 12.0234 6.95703C8.7982 6.95703 5.57297 6.95703 2.25 6.95703C2.25 6.45816 2.25 5.9593 2.25 5.44531Z"
      fill="black"
    />
    <path
      d="M14.6602 6.18359C14.8069 6.25108 14.9097 6.35088 15.0234 6.46347C15.0443 6.48411 15.0653 6.50474 15.0869 6.526C15.131 6.56958 15.175 6.61326 15.2189 6.65704C15.2863 6.72407 15.3544 6.79043 15.4225 6.85678C15.4653 6.89922 15.508 6.9417 15.5507 6.98422C15.5712 7.00404 15.5917 7.02386 15.6129 7.04427C15.6691 7.10114 15.6691 7.10114 15.75 7.20312C15.7397 7.31917 15.6941 7.37759 15.6132 7.45809C15.5807 7.49077 15.5807 7.49077 15.5476 7.52411C15.5237 7.54761 15.4999 7.5711 15.4753 7.5953C15.4502 7.62035 15.4252 7.64541 15.3994 7.67122C15.3165 7.75403 15.2333 7.83645 15.15 7.91888C15.0925 7.9762 15.035 8.03354 14.9775 8.0909C14.8262 8.24187 14.6745 8.39251 14.5227 8.54309C14.368 8.69679 14.2135 8.85078 14.059 9.00475C13.7558 9.30684 13.4522 9.6086 13.1484 9.91016C13.1946 10.0123 13.2438 10.0844 13.3235 10.1628C13.345 10.1841 13.3664 10.2054 13.3885 10.2274C13.412 10.2503 13.4355 10.2732 13.4597 10.2969C13.4968 10.3336 13.4968 10.3336 13.5347 10.3711C13.5884 10.4242 13.6422 10.4772 13.696 10.5301C13.7811 10.6139 13.866 10.6978 13.9508 10.7819C14.1918 11.0209 14.4332 11.2596 14.675 11.4977C14.823 11.6434 14.9705 11.7895 15.1177 11.9358C15.174 11.9916 15.2305 12.0472 15.2871 12.1027C15.366 12.18 15.4444 12.2579 15.5227 12.3359C15.5583 12.3704 15.5583 12.3704 15.5945 12.4055C15.6157 12.4267 15.6368 12.448 15.6586 12.47C15.6865 12.4975 15.6865 12.4975 15.715 12.5256C15.75 12.582 15.75 12.582 15.7407 12.656C15.7112 12.732 15.6784 12.7718 15.6205 12.829C15.6008 12.8487 15.5811 12.8684 15.5608 12.8887C15.5394 12.9095 15.5181 12.9303 15.4961 12.9517C15.4743 12.9734 15.4525 12.995 15.43 13.0173C15.3604 13.0863 15.2904 13.155 15.2205 13.2236C15.1732 13.2704 15.1259 13.3172 15.0787 13.364C14.9629 13.4786 14.8468 13.5929 14.7305 13.707C14.6075 13.6543 14.5283 13.5838 14.4341 13.4895C14.3877 13.4432 14.3877 13.4432 14.3403 13.3959C14.3063 13.3617 14.2723 13.3274 14.2382 13.2931C14.2022 13.2571 14.1662 13.221 14.1301 13.185C14.0323 13.0873 13.9348 12.9893 13.8373 12.8913C13.7353 12.7889 13.6331 12.6867 13.531 12.5844C13.3376 12.3908 13.1444 12.1971 12.9513 12.0032C12.7314 11.7825 12.5113 11.5621 12.2912 11.3416C11.8384 10.8881 11.3859 10.4344 10.9336 9.98047C10.9863 9.85749 11.0568 9.77826 11.1512 9.68413C11.1975 9.63769 11.1975 9.63769 11.2447 9.59032C11.279 9.55629 11.3132 9.52227 11.3475 9.48825C11.3836 9.45222 11.4196 9.41618 11.4556 9.38012C11.5534 9.28235 11.6513 9.1848 11.7493 9.08728C11.8518 8.98531 11.954 8.88314 12.0562 8.78099C12.2498 8.58761 12.4436 8.39442 12.6374 8.20129C12.8581 7.98139 13.0786 7.7613 13.299 7.54118C13.7525 7.08843 14.2063 6.63593 14.6602 6.18359Z"
      fill="black"
    />
    <path
      d="M2.25 9.17188C4.73273 9.17188 7.21547 9.17188 9.77344 9.17188C9.77344 9.68234 9.77344 10.1928 9.77344 10.7188C7.2907 10.7188 4.80797 10.7188 2.25 10.7188C2.25 10.2083 2.25 9.69781 2.25 9.17188Z"
      fill="black"
    />
  </svg>
);

const Navigation = (props) => {
  const {
    theme,
    Constants,
    userData,
    routeConstants,
    moduleTypeConstants,
    AdminAccessConstants,
    permissionConstants,
  } = props;

  const { MenuOrientation, ThemeMode } = props?.config;

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState("");
  const [selectedLevel, setSelectedLevel] = useState(0);
  const [menuItems, setMenuItems] = useState({ items: [] });
  const [permissionData, setPermissionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Function to generate contents based on pathname and userData
  const generateContents = (userData) => {
    let baseContents;
    if (userData?.externalUser) {
      baseContents = {
        id: "contents",
        title: "",
        type: "group",
        children: [],
      };
    } else {
      baseContents = {
        id: "contents",
        title: "Contents",
        type: "group",
        children: [
          {
            id: "Change Note",
            title: "Change Note",
            type: "item",
            url: `/change-note/detail/${getMasterDocDataByKey({ defaultName: FormatConstants.COD.CHANGE_NOTE })?.masterDocId}`,
            icon: icons.ChangeHistoryIcon,
            permissionKey: null,
          },
          {
            id: "Users",
            title: "Users",
            type: "item",
            url: "/users",
            icon: icons.client,
            permissionKey: AdminAccessConstants.USERS,
          },
          // {
          //   id: "Standards",
          //   title: "Standards",
          //   type: "item",
          //   url: "/standards/standard-list",
          //   icon: icons.standard,
          //   permissionKey: null,
          // },
          {
            id: "Dynamic Document",
            title: "Dynamic Document",
            type: "item",
            url: "/dynamic-document/manage",
            icon: icons.table,
            permissionKey: AdminAccessConstants.DYNAMIC_DOCUMENT,
          },
          {
            id: "Master Table",
            title: "Master Table",
            type: "item",
            url: "/master-table",
            icon: icons.table,
            permissionKey: AdminAccessConstants?.MASTERTABLE,
          },
          {
            id: "Finished Product Register",
            title: "Finished Product Register",
            type: "item",
            url:`/finished-product-register/detail/${getMasterDocDataByKey({defaultName:FormatConstants.PRODUCTION.PRODUCT_LIST})?.masterDocId}`,
            icon: icons.finish,
            permissionKey:
              FormatConstants.FINISHED_REGISTER_PRODUCT
                .FINISHED_PRODUCT_REGISTER,
          },
          // {
          //   id: "Permissions",
          //   title: "Permissions",
          //   type: "item",
          //   url: "/permission",
          //   icon: icons.table,
          //   permissionKey: null,
          // },
          // {
          //   id: "comptency-matrix",
          //   title: "Competency Matrix",
          //   type: "item",
          //   url: `/${routeConstants.CAT}/view/${ConvertToKebabCase(
          //     FormatConstants.CAT.COMPETENCY_MATRIX
          //   )}`,
          //   icon: icons.Box,
          //   permissionKey: FormatConstants.CAT.COMPETENCY_MATRIX,
          // },
          {
            id: "training-calender",
            title: "Training Calender",
            type: "item",
            url: `/${routeConstants.CAT}/records/year-wise`,
            icon: icons.calendar,
            permissionKey: FormatConstants.CAT.TRAINING_CALENDAR,
          },
          {
            id: "Calendar",
            title: "Calendar",
            type: "item",
            url: "/calendar",
            icon: icons.calendar,
            permissionKey: AdminAccessConstants?.CALENDAR,
          },
          {
            id: "Audit-Trail",
            title: "Audit Trail",
            type: "item",
            url: "/audit-trail/user-list",
            icon: icons.Timeline,
            permissionKey: null,
          },
          // {
          //   id: "General",
          //   title: "General",
          //   type: "collapse",
          //   icon: icons.general,
          //   children: [],
          // },
        ],
      };
    }
    const updatedContents = baseContents?.children
      ?.map((child) => {
        if (child.type === "item") {
          // Keep item if no permission is required or if user has the required permission
          return child.permissionKey === null ||
            checkPermission(
              permissionData,
              child.permissionKey,
              permissionConstants?.READ
            )
            ? child
            : null;
        } else if (child.type === "collapse") {
          // Filter children inside collapse
          const filteredChildren = child?.children?.filter(
            (sub) =>
              sub?.permissionKey === null ||
              checkPermission(
                permissionData,
                sub.permissionKey,
                permissionConstants?.READ
              )
          );

          // Keep collapse if it has at least one valid child
          const updatedChild = { ...child, children: filteredChildren ?? [] };
          return updatedChild;
        }
        return child;
      })
      .filter(Boolean); // Remove null values
    return { ...baseContents, children: updatedContents };
  };

  // let userData = getItem(Constants.KEY_USER_DATA);
  // let contents = generateContents(userData);

  // useEffect(() => {
  //   let data = {
  //     items: [...menuItem.items, contents],
  //   };
  //   setMenuItems(data);
  //   // eslint-disable-next-line
  // }, [menuItem, location?.pathname]);

  useEffect(() => {
    let userData = getItem(Constants.KEY_USER_DATA);
    let contents;
    if (userData?.externalUser) {
      contents = generateContents(userData);
    } else if (!userData?.externalUser && permissionData?.length > 0) {
      contents = generateContents(userData);
    }

    let data = {
      items: [...menuItem.items, contents],
    };
    setMenuItems(data);
    setIsLoading(false);
  }, [permissionData, menuItem, location?.pathname]); // Runs only when permissionData is set

  useEffect(() => {
    userData && !userData?.externalUser && getPermissionData();
  }, []);

  const getPermissionData = async () => {
    const [result, slugPermissions] = await Promise.all([
      getPermssionDataByName([
        FormatConstants.FINISHED_REGISTER_PRODUCT.FINISHED_PRODUCT_REGISTER,
        FormatConstants.CAT.COMPETENCY_MATRIX,
        FormatConstants.CAT.TRAINING_CALENDAR,
        FormatConstants.CAT.INDUCTION_TRAINING_RECORD,
        FormatConstants.CAT.REQUISITION_FOR_MANPOWER,
      ]),
      getPermssionDataByName(undefined, moduleTypeConstants.ADMIN, {
        slug: [
          AdminAccessConstants?.USERS,
          AdminAccessConstants?.DYNAMIC_DOCUMENT,
          AdminAccessConstants?.MASTERTABLE,
          AdminAccessConstants?.MASTERPRODUCTS,
          AdminAccessConstants?.CALENDAR,
        ],
      }),
    ]);

    setPermissionData([...(result || []), ...(slugPermissions || [])]);
  };

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems?.items?.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItems?.items?.length) {
    lastItemId = menuItems?.items[lastItem - 1]?.id;
    lastItemIndex = lastItem - 1;
    remItems = menuItems?.items
      .slice(lastItem - 1, menuItems?.items?.length)
      .map((item, index) => ({
        index: index,
        title: item?.title,
        elements: item?.children,
        icon: item?.icon,
      }));
  }

  const navGroups = menuItems?.items
    ?.slice(0, lastItemIndex + 1)
    .map((item, index) => {
      switch (item?.type) {
        case "group":
          return (
            <NavGroup
              key={index}
              setSelectedItems={setSelectedItems}
              setSelectedLevel={setSelectedLevel}
              selectedLevel={selectedLevel}
              selectedItems={selectedItems}
              lastItem={lastItem}
              remItems={remItems}
              lastItemId={lastItemId}
              item={item}
            />
          );
        default:
          return (
            <Typography key={index} variant="h6" color="error" align="center">
              {/* Fix - Navigation Group */}
            </Typography>
          );
      }
    });

  return (
    <Box
      sx={{
        mt: "10px",
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        "& > ul:first-of-type": { mt: 0 },
        display: isHorizontal ? { xs: "block", lg: "flex" } : "block",
        // border: '1px solid red'
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          gap: "7px",
          justifyContent: drawerOpen ? "start" : "center",
          marginX: "10px",
          borderRadius: "10px",
          color: "#5B6B79",
          "&:hover": drawerOpen
            ? {
                // color: '#4680FF',
                bgcolor: drawerOpen ? "rgba(255, 255, 255, 0.7)" : "#E9F0FF",
              }
            : {},
        }}
        onClick={() => dispatch(openDrawer(!drawerOpen))}
      >
        <IconButton
          aria-label="open drawer"
          edge="start"
          color="secondary"
          variant="light"
          size="large"
          sx={{
            color: "secondary.main",
            borderRadius: 100,
            borderRadius: "",
            "&:hover": {
              bgcolor: "#E9F0FF",
            },
            marginLeft: drawerOpen ? "6px" : "0.5px",
          }}
        >
          <Hamberger />
        </IconButton>
        {
          (drawerOpen) && (
            <Box sx={{
              alignContent: 'center',

            }}
            >
              <Typography sx={{
                fontWeight: 500,
                fontSize: '14px'
              }}>Close Sidebar</Typography>
            </Box>
          )
        }
      </Box> */}
      {isLoading ? (
        <Stack spacing={2} sx={{ p: 2 }}>
          {[...Array(8)]?.map((_, i) => (
            <Skeleton key={i} variant="circular" width={40} height={40} />
          ))}
        </Stack>
      ) : (
        navGroups
      )}
    </Box>
  );
};

export default withRouter(Navigation);
